import React from 'react';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IoIosAdd, IoIosRemove } from 'react-icons/io';
import BootstrapTable from 'react-bootstrap-table-next';
import i18n from 'i18next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

function OrderCard(props) {
    const { t } = useTranslation();
    const { language } = i18n;

    const getStatus = (status) => {
        if (props.orderMeta && props.orderMeta.statuses) {
            let statuses;

            if (language === 'fi') {
                statuses = props.orderMeta.statuses.partner;
            } else {
                statuses = [
                    ...props.orderMeta.statuses.app.General,
                    ...props.orderMeta.statuses.app.Other,
                    ...props.orderMeta.statuses.app.Payment
                ];
            }

			statuses.forEach((metaStatus)=>{
				if (metaStatus.id === status) {
					status = metaStatus.text;
				}
			})
        }
		return status;
    };

    const getRowStatus = (status) => {
        if (props.orderRowsMeta && props.orderRowsMeta.statuses) {
            let statuses;

            if (language === 'fi') {
                statuses = props.orderRowsMeta.statuses.partner;
            } else {
                statuses = props.orderRowsMeta.statuses.app;
            }

            statuses.forEach((metaStatus) => {
                if (metaStatus.id === status) {
                    status = metaStatus.name;
                }
            });
        }
        return status;
    };

    const orderRowsData = props.order.orderRows ? props.order.orderRows.map(orderRow => {
        return {
            key: orderRow.orderRowID,
            productID: orderRow.productID,
            productName: orderRow.product.name,
            productCount: orderRow.productCount,
            sku: orderRow.product.sku,
            productPrice: orderRow.product.totalPriceRounded + '€',
            totalVat: orderRow.taxAmount + '€',
            totalPrice: orderRow.totalPriceIncludingProductCount + '€',
            totalWithoutTax: orderRow.originalPriceWithoutTaxRounded + '€',
            isBundle: orderRow.product.isBundle,
            bundledProducts: orderRow.product.bundledProducts,
            tickets: orderRow.tickets && orderRow.tickets.length ? orderRow.tickets : null,
            status: orderRow.status,
            orderRowStatusText: orderRow.orderRowStatusText,
            statusText: getRowStatus(orderRow.status)
        }
    }).sort((a, b) => {
        return new Date(b.timeCreated) - new Date(a.timeCreated);
    }) : [];

    const billingInformationCells = [/* 'firstNames', 'lastName', */'email', 'phone', 'invoiceCompany', 'invoiceStreetAddress', 'invoiceCity', 'invoicePostalCode'];
    const billingInformation = billingInformationCells.map(cell => {
        if (props.order[cell]) {
            return (
                <span key={cell}>
                    {props.order[cell]} <br />
                </span>
            );
        }
        return '';
    });

    const columns = [{
        dataField: 'productName',
        text: t('orders.product_name')
      }, {
        dataField: 'statusText',
        text: t('orders.order_row_status')
      }, {
        dataField: 'sku',
        text: t('orders.sku')
      }, {
        dataField: 'productCount',
        text: t('orders.amount')
      }, {
        dataField: 'totalWithoutTax',
        text: t('orders.total_w/o_tax')
      }, {
        dataField: 'totalVat',
        text: t('orders.vat_total')
      }, {
        dataField: 'totalPrice',
        text: t('orders.total')
    }];

    const expandRow = {
        renderer: row => (
            <div style={{ marginLeft: 32 }}>
                <strong>{row.bundledProducts ? t('products.bundled_products') : t('orders.tickets')}</strong>
                {row.bundledProducts && row.bundledProducts.map(p => (
                    <div
                        key={p.productBundleID}
                        className="col-sm-2 p-0 d-flex justify-content-between"
                    >
                        <div>{p.name}</div>
                        <div>{p.quantity} {t('products.pcs')}</div>
                    </div>
                ))}
                {row.tickets && row.tickets.map(t => (
                    <div
                        key={t.ticketID}
                        className="col-sm-6 p-0 d-flex justify-content-between"
                    >
                        <div>
                            <a href={t.ticketUrl} target="_blank" rel="noopener noreferrer">{t.ticketID}</a>
                        </div>
                    </div>
                ))}
            </div>
        ),
        expandHeaderColumnRenderer: () => null,
        expandColumnRenderer: ({ expandable, expanded }) => (
            <>
                {!expandable ? null :
                    <div style={{ cursor: 'pointer' }}>
                        {expanded ? <IoIosRemove color="#007bff" size={20} /> : <IoIosAdd color="#007bff" size={20} />}
                    </div>
                }
            </>
        ),
        showExpandColumn: true,
        expandByColumnOnly: true,
        nonExpandable: orderRowsData.filter(r => !r.bundledProducts && !r.tickets).map(r => r.key)
    };

    return (
        <>
            <Row>
                <Col sm={5}>
                    <p>
                        <strong>{t('general.status')}</strong><br />
                        {getStatus(props.order.status)}<br />
                    </p>
                    <p>
                        <strong>{t('orders.order_name')}</strong><br />
                        {props.order.name ? props.order.name + (props.order.orderNumber ? ' (' + props.order.orderNumber + ')' : '') : (props.order.orderNumber ? props.order.orderNumber : props.order.orderID)}<br />
                    </p>
                    <p>
                        <strong>{t('orders.date')}</strong><br />
                        {props.order.timeModified ?
                            <span>
                                {moment(props.order.timeModified).format('DD.MM.YYYY ')}
                            </span> :
                            <span>
                                {moment(props.order.timeCreated).format('DD.MM.YYYY ')}
                            </span>
                        }
                    </p>
                </Col>
                <Col sm={7}>
                    <strong>{t('orders.billing_information')}</strong><br />
                    {(props.order.firstNames || '') + ' ' + (props.order.lastName || '')} <br />
                    {billingInformation}
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <hr />
                    <BootstrapTable
                        striped
                        bordered={false}
                        keyField="key"
                        data={orderRowsData}
                        columns={columns}
                        expandRow={expandRow}
                        bootstrap4={true}
                        wrapperClasses="table-responsive"
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <p className="pull-right">
                        <strong><span className="priceLabel">{t('orders.total_tax')}</span></strong>&nbsp;
                        <span className="priceTag">{parseFloat(props.order.totalTaxConfirmed ? props.order.totalTaxConfirmed : '0').toFixed(2)} €</span>
                    </p>
                </Col>
                <Col sm={12}>
                    <p className="pull-right">
                        <strong><span className="priceLabel">{t('orders.total_price_w/o_tax')}</span></strong>&nbsp;
                        <span className="priceTag">{parseFloat(props.order.totalWithoutTaxConfirmed ? props.order.totalWithoutTaxConfirmed : '0').toFixed(2)} €</span>
                    </p>
                </Col>
                <Col sm={12}>
                    <p className="pull-right">
                        <strong><span className="priceLabel">{t('orders.total')}</span></strong>&nbsp;
                        <span className="priceTag">{parseFloat(props.order.totalConfirmed ? props.order.totalConfirmed : '0').toFixed(2)} €</span>
                    </p>
                </Col>
            </Row>
        </>
    );
}

export default OrderCard;
